var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { useTranslate, linkToRecord } from 'ra-core';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import { makeStyles } from '@material-ui/core/styles';
import { useCopyToClipboard } from '../../ui';
import { useHistory } from 'react-router-dom';
const useOneTimePasswordDialogStyles = makeStyles(theme => ({
    mainContent: {
        display: 'flex',
        flexDirection: 'row',
    },
    leftSection: {
        flex: '1',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: theme.spacing(0),
        padding: theme.spacing(1),
        backgroundColor: theme.palette.warning.main,
        color: theme.palette.common.white,
    },
    leftIcon: {
        fontSize: '5rem',
        color: theme.palette.common.white,
    },
    rightSection: {
        flex: '5',
        flexDirection: 'row',
    },
    subHeading: {
        textTransform: 'uppercase',
        fontWeight: theme.typography.fontWeightBold,
    },
    copyHashSection: {
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(1),
        textAlign: 'center',
    },
}), {
    name: 'Layer7ApplicationOneTimePasswordDialog',
});
export const OneTimePasswordDialog = (_a) => {
    var { id, keySecret } = _a, props = __rest(_a, ["id", "keySecret"]);
    const [open, setOpen] = useState(true);
    const history = useHistory();
    const classes = useOneTimePasswordDialogStyles();
    const copyToClipboard = useCopyToClipboard({
        successMessage: 'resources.applications.notifications.copy_success',
        errorMessage: 'resources.applications.notifications.copy_error',
    });
    const translate = useTranslate();
    const handleDialogClose = () => {
        if (open) {
            setOpen(false);
        }
        history.push(linkToRecord('/applications', id, 'show'));
    };
    return (React.createElement(Dialog, { disableBackdropClick: "false", disableEscapeKeyDown: "false", open: open, onClose: handleDialogClose, "aria-labelledby": "form-dialog-title" },
        React.createElement("div", { className: classes.mainContent },
            React.createElement("div", { className: classes.leftSection },
                React.createElement(ReportProblemOutlinedIcon, { className: classes.leftIcon })),
            React.createElement("div", { className: classes.rightSection },
                React.createElement(DialogTitle, { id: "form-dialog-title" }, translate('resources.applications.notifications.secret_generated_heading')),
                React.createElement(DialogContent, { dividers: true },
                    React.createElement(Typography, { variant: "subtitle1", component: "h2", className: classes.subHeading, gutterBottom: true }, translate('resources.applications.notifications.copy_secret_now')),
                    React.createElement(Typography, { variant: "body1", gutterBottom: true }, translate('resources.applications.notifications.secret_generated_message')),
                    React.createElement("div", { className: classes.copyHashSection },
                        React.createElement(Typography, { variant: "subtitle2", gutterBottom: true }, translate('resources.applications.fields.sharedSecretClientSecret')),
                        React.createElement(Typography, { variant: "body1", gutterBottom: true }, keySecret),
                        React.createElement(Button, { onClick: copyToClipboard, value: keySecret, align: "center", variant: "contained", color: "primary" }, translate('resources.applications.notifications.copy_to_clipboard')))),
                React.createElement(DialogActions, null,
                    React.createElement(Button, { onClick: handleDialogClose, color: "secondary" }, translate('ra.action.close')))))));
};
//# sourceMappingURL=OneTimePasswordDialog.js.map